import React, { Component } from 'react'
import { gotoDashboard } from '../utilities/customRoutes'

export default class ErrorPage extends Component {

    render() {
        return (
            <div className="bb-error-page d-flex flex-column justify-content-center align-items-center flex-grow-1">
                <img className="img-fluid" src="/images/404/404Face.svg" alt="" />
                <p className="text-center">Access Denied! <br/>Please contact your system administrator for more information.</p>
                <button className="rounded bb-bg_primary text-white border-0 p-2" onClick={() => gotoDashboard()}>
                    Back to My Deals
                </button>
            </div>

        );
    }
} 